const Spacing: () => JSX.Element = () => {
  return <>{'\u00A0 \u00A0'}</>
};
export default Spacing;
